import externalApiRequest from 'services/externalApiRequest';

const connector = (data) => {
    const { api = '', content = {}, urlAppend = '', extraHeaders = {}, ignoreAllError = false } = data,
        options = {
            api,
            content,
            urlAppend,
            extraHeaders,
            ignoreAllError
        };
    return externalApiRequest(options).then((responseData) => {
        return responseData;
    });
};

export default connector;
